import Loader from '~components/generic/loader/Loader';
import { useUsergroups } from '~services/api/hooks/user-management.hooks';
import { AddUsergroupForm } from './AddUsergroupForm';
import { UsergroupsList } from './UsergroupsList';
import styles from './EditUsergroups.module.css';

export type EditUsergroupsProps = {
  /* Nothing yet */
};

export const EditUsergroups = (_props: EditUsergroupsProps) => {
  // Define: fetch usergroups query
  const { isLoading, data } = useUsergroups();

  if (isLoading) {
    return (
      <div className={styles.loader}>
        <Loader theme="dark" />
      </div>
    );
  }

  return (
    <>
      <UsergroupsList usergroups={data} />
      <div className={styles.new}>
        <AddUsergroupForm />
      </div>
    </>
  );
};
